import { combineReducers } from '@reduxjs/toolkit';

import type { State as reportConfigurationState } from './reportConfiguration/reducers';

import { INITIAL_STATE as REPORT_CONFIGURATION_INITIAL_STATE } from './reportConfiguration/reducers';

import reportConfigurationSlice from './reportConfiguration/reducers';

export interface State {
	reportConfiguration: reportConfigurationState
};

export const INITIAL_STATE: State = {
	reportConfiguration: {...REPORT_CONFIGURATION_INITIAL_STATE}
};

export const reducers = combineReducers({
	reportConfiguration: reportConfigurationSlice
});
